<app-actions [id]="id" type="License" [action]="VIEW" [service]="deleteLicense"></app-actions>
<ng-container *ngIf="data$ | async as data">
  <app-form-group icon="one-icon-user-tooltip" title="General Information">
    <app-view-form-field label="License ID" [value]="id" [disabled]="true"></app-view-form-field>
    <app-view-form-field label="Email Address" [value]="data.email"></app-view-form-field>
  </app-form-group>
</ng-container>
